import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiSupportStaffListGet } from '@/entities/support-staff/modules/api/support-staff';
import type { ApiSupportStaffListParams } from '@/shared/types/api/support-staff';

export const useSupportStaffList = (params: ApiSupportStaffListParams) =>
  useFetch({
    api: () => apiSupportStaffListGet(params),
    keywords: queryKeys.supportStaff.list(params),
    staleTime: 60_000,
  });
